var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "header" }, [
    this.$store.getters.getFormChangeState
      ? _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "cell auto text-center" }, [
            _c(
              "div",
              { staticClass: "callout warning callout--fixed-header" },
              [_vm._v(_vm._s(_vm.$t("weeks.warning.changesnotsaved")))]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header__wrapper" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "logo",
            attrs: {
              to: { name: "home" },
              title: _vm.$t("nav.logo"),
              tabindex: "-1",
            },
          },
          [
            _c("img", {
              attrs: { src: "/assets/img/as-logo.svg", alt: "AS Asphaltbau" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("nav", { staticClass: "navigation navigation--header" }, [
          _vm.$store.getters.userIsAdmin
            ? _c("ul", [
                _vm.$store.getters.userHasPermission("customer_list")
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "customers" },
                              title: _vm.$t("nav.customers"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.customers")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userHasPermission("project_list")
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "projects" },
                              title: _vm.$t("nav.projects"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.projects")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userIsAdmin
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "tours" },
                              title: _vm.$t("nav.tours"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.tours")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userIsAdmin
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "weeks" },
                              title: _vm.$t("nav.weeks"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.weeks")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userIsAdmin
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "projectmap" },
                              title: _vm.$t("nav.projectmap"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.projectmap")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userHasPermission("mixingplant_list")
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "search-mixingplants" },
                              title: `Mischanlagen`,
                              tabindex: "-1",
                            },
                          },
                          [_vm._v("Mischanlagen")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.userCanAccessKiMvp
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "project-planning-export" },
                              title: _vm.$t("nav.projectplanningexport"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.projectplanningexport")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm.$store.getters.userHasPermission("customer_view")
            ? _c("ul", [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "customers-view-customer",
                            params: {
                              customer: _vm.$store.getters.getUser.customer.id,
                            },
                          },
                          title: _vm.$t("nav.customer"),
                          tabindex: "-1",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("customers.overview")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$store.getters.userHasPermission("project_list")
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "customers-view-customer-projects",
                                params: {
                                  customer:
                                    _vm.$store.getters.getUser.customer.id,
                                },
                              },
                              title: _vm.$t("nav.projects"),
                              tabindex: "-1",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.projects")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.$store.getters.getUser.loggedin === true
          ? _c("div", { staticClass: "header__search" }, [
              _c(
                "form",
                {
                  staticClass: "header__search__form",
                  attrs: {
                    action: "",
                    name: "search-form",
                    autocomplete: "off",
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    attrs: {
                      type: "text",
                      name: "searchvalue",
                      tabindex: "-1",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      keyup: function ($event) {
                        return _vm.onUpdateSearch()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        role: "button",
                        type: "submit",
                        title: _vm.$t("search"),
                        tabindex: "-1",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search")))]
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.searchIsEmpty
                ? _c(
                    "div",
                    {
                      staticClass: "header__search__suggestions",
                      class: { "is-loading": _vm.searchLoading },
                    },
                    [
                      _vm.searchItems.length === 0 && !_vm.searchLoading
                        ? [_c("p", [_vm._v(_vm._s(_vm.$t("search.empty")))])]
                        : _vm._l(_vm.searchItems, function (item, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                item.results
                                  ? [
                                      _c("h2", [_vm._v(_vm._s(item.label))]),
                                      _vm._v(" "),
                                      _vm._l(
                                        item.results,
                                        function (result, index) {
                                          return _c(
                                            "ul",
                                            {
                                              key: index,
                                              attrs: { template: "" },
                                            },
                                            [
                                              _c(
                                                "li",
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: result.router,
                                                        title: result.title,
                                                        tabindex: "-1",
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onSearchItemClick.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(result.title)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header__options" },
          [
            _vm.$store.getters.getUser.loggedin === true
              ? _c("v-header-notifications")
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "header__options__item" }, [
              _c(
                "button",
                {
                  staticClass: "profile",
                  attrs: {
                    role: "button",
                    title: _vm.$t("nav.account"),
                    tabindex: "-1",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("nav.account")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header__dropdown" }, [
                _c("div", { staticClass: "header__dropdown__wrapper" }, [
                  _c(
                    "nav",
                    {
                      staticClass:
                        "profile-navigation profile-navigation--header-dropdown on",
                    },
                    [
                      _c(
                        "ul",
                        [
                          _vm.$store.getters.getUser.loggedin === true &&
                          _vm.$store.getters.userHasPermission("profile")
                            ? [
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "account-update-profile",
                                          },
                                          title: _vm.$t(
                                            "account.profile.update"
                                          ),
                                          tabindex: "-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("account.profile.update")
                                            ) +
                                            "\n                      "
                                        ),
                                        _c("span", {
                                          staticClass: "icon icon--edit",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "account-update-password",
                                          },
                                          title: _vm.$t(
                                            "account.profile.password.update"
                                          ),
                                          tabindex: "-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "account.profile.password.update"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                        _c("span", {
                                          staticClass: "icon icon--edit",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "logout" },
                                          title: _vm.$t("nav.logout"),
                                          tabindex: "-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.$t("nav.logout")) +
                                            "\n                      "
                                        ),
                                        _c("span", {
                                          staticClass: "icon icon--logout",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "login" },
                                          title: _vm.$t("nav.login"),
                                          tabindex: "-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.$t("nav.login")) +
                                            "\n                      "
                                        ),
                                        _c("span", {
                                          staticClass: "icon icon--login",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "nav-toggle",
        attrs: { role: "button", title: "Menu", tabindex: "-1" },
      },
      [_c("span", { staticClass: "bar" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }